module.exports = __webpack_public_path__ + "4584cf20cb4009cc2bcc337ef008605f.pdf";